import React, { useState, useRef, useLayoutEffect } from 'react'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  margin: auto;
  max-width: 757px;
  position: relative;
  width: 100%;
`

const StyledScale = styled.div`
  background-color: #4e5d78;
  border-radius: 16px;
  height: 10px;
  position: absolute;
  width: 100%;
`

const StyledScaleFilled = styled.div.attrs(({ width }) => ({
  style: { width: `${width}%` },
}))`
  background-color: #7f1518;
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  height: 10px;
  overflow: hidden;
  position: absolute;
  top: 0;
`

const StyledRange = styled.input.attrs((value, onChange) => ({
  max: '24',
  min: '0',
  onChange: onChange,
  type: 'range',
  value: value,
}))`
  -webkit-appearance: none;
  outline: none;
  position: relative;
  width: 100%;
  z-index: 100;

  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background-color: #c02428;
    border-radius: 20px;
    cursor: pointer;
    height: 32px;
    margin-top: -10px;
    width: 32px;
  }

  ::-moz-range-thumb {
    background-color: #d2d2d2;
    border: 8px solid #ffffff;
    border-radius: 16px;
    box-shadow: 0px 0px 0px 1px #d2d2d2;
    cursor: pointer;
    height: revert;
  }
`

const InputRange = ({
  initialValue,
  values,
  singleColor,
  onChange = () => null,
}) => {
  const [inputValue, setInputValue] = useState(initialValue)
  const [componentWidth, setComponentWidth] = useState(initialValue)
  const component = useRef(null)

  useLayoutEffect(() => {
    setComponentWidth(component.current.clientWidth + 'px')
  }, [])

  const handleChange = e => {
    setInputValue(e.target.value)
    onChange(values[e.target.value])
  }

  return (
    <StyledWrapper ref={component}>
      <StyledScale singleColor={singleColor}>
        <StyledScaleFilled
          width={inputValue * 4}
          totalWidth={componentWidth}
          singleColor={singleColor}
        />
      </StyledScale>

      <StyledRange
        singleColor={singleColor}
        value={inputValue}
        onChange={handleChange}
        color={inputValue}
      />
    </StyledWrapper>
  )
}

export default InputRange
